import React from 'react';
import { Platform, View } from 'react-native';
import { createStyleSheet } from '../../utils';
import { useStyleSheet } from '../../hooks';
import { User } from '../User';
import { Text } from '../Text';
export const Participants = ({ data, limit, style, light }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: [styles.container, style] },
        data.slice(0, limit).map(({ name, image, type, id }, index) => (React.createElement(View, { key: id, style: [
                styles.participant,
                index === 0 ? null : styles.participantWithMargin
            ] },
            React.createElement(User, { name: name, type: type, image: image, size: 'sm' })))),
        data.length > limit && (React.createElement(View, { style: [
                styles.participant,
                styles.participantWithMargin,
                styles.participantPlaceholder
            ] },
            React.createElement(View, { style: styles.participantPlaceholderWrapper },
                React.createElement(Text, { type: 'body', size: 'sm', weight: 'semibold' },
                    data.length - limit,
                    "+")))),
        React.createElement(Text, { type: 'headline', size: 'lg', style: [styles.title, light ? styles.title__isLight : {}], numberOfLines: 1, ellipsizeMode: 'tail' }, data.length === 1
            ? data[0].name
            : data.length === 2
                ? `${data[0].name} and ${data[1].name}`
                : `${data[0].name} and ${data.length - 1} others`)));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    participant: {},
    participantWithMargin: {
        marginLeft: -size.D,
        borderRadius: 9999,
        borderWidth: size.A,
        borderColor: color.bg.v1,
        backgroundColor: color.bg.v1
    },
    title: {
        color: color.invert2.p100,
        marginLeft: size.C,
        maxWidth: Platform.OS !== 'web' ? 288 : 200
    },
    title__isLight: {
        color: color.white.p100
    },
    participantPlaceholder: {
        backgroundColor: color.bg.v1,
        overflow: 'hidden'
    },
    participantPlaceholderWrapper: {
        backgroundColor: color.pending.ghost,
        width: size.K,
        height: size.K,
        alignItems: 'center',
        justifyContent: 'center'
    }
}));
//# sourceMappingURL=index.js.map